/**
 * Vuex-persist: only cache list/catalog state — not *Edit drafts (wrong record on open, esp. mobile Safari).
 * unsavedUsers / unsavedEvents stay persisted for list draft badges.
 */
export const PERSISTED_STATE_PATHS = [
  'admin',
  'category',
  'rallyCategory',
  'connection',
  'moderator',
  'stripe',
  'tag',
  'dealTemplate',
  'company.companies',
  'company.loading',
  'company.error',
  'rally.rallys',
  'rally.loading',
  'rally.error',
  'event.events',
  'event.loading',
  'event.error',
  'event.unsavedEvents',
  'special.specials',
  'special.loading',
  'special.error',
  'user.users',
  'user.loading',
  'user.error',
  'user.unsavedUsers',
  'hobby.hobbys',
  'hobby.loading',
  'hobby.error',
  'interest.interests',
  'interest.loading',
  'interest.error',
];
